import React from "react";
import { MapperFacade } from "./MapperFacade.js";
const AutoMapperContext = React.createContext({ mapper: null });
function AutoMapperProvider({ children, mapper }) {
  return /* @__PURE__ */ React.createElement(AutoMapperContext.Provider, { value: { mapper: new MapperFacade(mapper) } }, children);
}
export {
  AutoMapperContext,
  AutoMapperProvider
};
//# sourceMappingURL=AutoMapperProvider.js.map
